<template>
    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="90%">
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="name" label="优享券名称" min-width="140"> </el-table-column>

            <el-table-column prop="exp_date_time.YmdHis" label="有效时间" min-width="100"> </el-table-column>

            <el-table-column prop="send_time.YmdHis" label="发放日期" min-width="100"> </el-table-column>

            <el-table-column prop="use_status.alias" label="状态" min-width="60"> </el-table-column>

            <el-table-column prop="use_time.YmdHis" label="使用日期" min-width="200"> </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="80"> </el-table-column>
            <el-table-column width="70" label="操作">
                <template slot-scope="scope">
                    <el-switch
                        :class="{
                            'pri-switch-close': scope.row.use_status.val == 0 || scope.row.use_status.val == 3,
                            'pri-switch-open': scope.row.use_status.val == 1
                        }"
                        v-if="scope.row.use_status.val != 2&&scope.row.use_status.val != 3"
                        v-model="scope.row.use_status.val"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0"
                        @change="executePriority(scope.row)"
                    >
                    </el-switch>


                </template>
            </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
let _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.search_data.driver_code = _this.data;

            _this.searchPriorityLists();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,

            search_data: {
                page: 1,
                limit: 10,
                driver_code: ''
            },

            tableData: [],
            search_data_execute: {
                driver_priority_record: '',
                priority_mode_code: '',
                driver_code: '',
                use_status: ''
            },
            result_data: {}
        };
    },
    methods: {
        executePriority(val) {
            console.log(val, 'val====');

            _this.search_data_execute.driver_priority_record = val.driver_priority_record;
            _this.search_data_execute.priority_mode_code = val.priority_mode_code;
            _this.search_data_execute.driver_code = val.driver_code;

            _this.search_data_execute.use_status = val.use_status.val;

            _this
                .$post('/priority/executePriorityStatusSubmit', _this.search_data_execute)
                .then((res) => {

                    _this.$message.success(res.msg);
                    _this.priorityLists();

                })
                .catch((err) => {});
        },
        priorityLists() {
            _this.$post('/priority/driverPriorityDetailsLists', _this.search_data).then((res) => {
                console.log(1133);
                _this.result_data = res;
                _this.tableData = res.data;
            });
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            // console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.priorityLists();
        },
        searchPriorityLists() {
            _this.search_data.page = 1;
            _this.priorityLists();
        }
    }
};
</script>

<style scoped>
.pagination {
    text-align: right;
}
</style>
<style>
.pri-switch-close .el-switch__core::after {
    content: '关';
    font-size: 14px;
    text-align: center;
    line-height: 16px;
    color: #ff4949;
}

.pri-switch-open .el-switch__core::after {
    content: '开';
    font-size: 14px;
    text-align: center;
    line-height: 16px;
    color: #13ce66;
}
</style>
